/// <summary>
/// 查询的结果类型
/// </summary>
export class  QueryResultType  {

	constructor()
	{

	}
}

	/// <summary>
	/// 行政区省信息
	/// </summary>
	QueryResultType.Area = 3;

	/// <summary>
	/// 线路信息
	/// </summary>
	QueryResultType.LineData = 5;
	/// <summary>
	/// POI点信息
	/// </summary>
	QueryResultType.POI = 1;
	/// <summary>
	/// 统计信息
	/// </summary>
	QueryResultType.Statistics = 2;
	/// <summary>
	/// 建议词信息
	/// </summary>
	QueryResultType.Suggest = 4;